/** Display labels for position form enums — API values stay English. */

export const POSITION_SENIORITY_VALUES = [
  'Junior',
  'Junior-Mid',
  'Mid',
  'Mid-Senior',
  'Senior',
] as const;

export const POSITION_CONTRACT_VALUES = [
  'Full-time',
  'Part-time',
  'Freelance',
  'Internship',
  'Temporary',
] as const;

export const POSITION_WORK_MODE_VALUES = ['On-site', 'Hybrid', 'Remote'] as const;

type Translate = (key: string) => string;

const SENIORITY_KEYS: Record<string, string> = {
  Junior: 'positions.seniorityJunior',
  'Junior-Mid': 'positions.seniorityJuniorMid',
  Mid: 'positions.seniorityMid',
  'Mid-Senior': 'positions.seniorityMidSenior',
  Senior: 'positions.senioritySenior',
};

const CONTRACT_KEYS: Record<string, string> = {
  'Full-time': 'positions.contractFullTime',
  'Part-time': 'positions.contractPartTime',
  Freelance: 'positions.contractFreelance',
  Internship: 'positions.contractInternship',
  Temporary: 'positions.contractTemporary',
};

const WORK_MODE_KEYS: Record<string, string> = {
  'On-site': 'positions.workModeOnSite',
  Hybrid: 'positions.workModeHybrid',
  Remote: 'positions.workModeRemote',
};

export function positionSeniorityLabel(t: Translate, value: string): string {
  const key = SENIORITY_KEYS[value];
  return key ? t(key) : value;
}

export function positionContractLabel(t: Translate, value: string): string {
  const key = CONTRACT_KEYS[value];
  return key ? t(key) : value;
}

export function positionWorkModeLabel(t: Translate, value: string): string {
  const key = WORK_MODE_KEYS[value];
  return key ? t(key) : value;
}
